import { ITranslations } from 'types/common';
import { AdminUsersTransFields } from './types';
import en from 'translations/en/adminUsers.json';
import pl from 'translations/pl/adminUsers.json';
import sl from 'translations/sl/adminUsers.json';

export const adminUsersTranslations: ITranslations<AdminUsersTransFields> = {
  name: 'adminUsers',
  en,
  pl,
  sl,
};
